/**
 * created 01.10.2025
 */
import React from 'react';
import type {PropsWithChildren} from 'react';
import './ProfileSettingsHeader.css';
import {useNavigate} from "react-router-dom";

type ProfileSettingsHeaderComponentType = PropsWithChildren<{
  title?: string;
}>

export function ProfileSettingsHeader(props: ProfileSettingsHeaderComponentType) {
  const {title = ''} = props;
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  }

  return <>
    <div className="profile-settings-header-container">
      <div className="mn-pr-set-ct">
        <div className="profile-settings-header-back-button-container">
          <button
            className={`header__back-button`}
            onClick={handleBack}
            aria-label="Go back"
          >
            <img
              src="/images/arrow-left.png"
              alt="Back"
              width="24"
              height="24"
            />
          </button>
        </div>
        <div className="profile-settings-header-main-container">
          <span>{title}</span>
        </div>
        <div className="profile-settings-header-space" />
      </div>
    </div>
  </>;
}
